<template>
  <div>
    <b-modal v-model="showModal"
      title="Habilitar módulos para pruebas"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="cancel"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc>
      <b-overlay :show="loading" rounded="sm">

        <p>Se habilitarán <b>todos los módulos</b> de la asignación <strong>{{ code }}</strong>:</p>

        <ul class="mb-3" style="padding-left: 1.1rem;">
          <li>El tiempo de <b>lectura</b> y de <b>práctica</b> pasa a ser el exigido por cada
              módulo, es decir, al 100&nbsp;%.</li>
          <li>Todos los módulos quedan <b>desbloqueados</b> («En curso»).</li>
        </ul>

        <div class="alert-expired mb-3">
          <b>Ojo:</b> esto <b>sobrescribe el progreso real</b> del alumno. Está pensado para
          probar el aula sin esperar las horas de lectura; sobre un alumno de verdad le estarías
          falsificando el avance.
        </div>

        <small class="text-muted d-block">
          No se tocan las notas: un módulo solo pasa a «Completado» aprobando su examen.
          Los módulos que se hayan añadido al curso después de asignarlo no tienen progreso y
          quedan fuera.
        </small>

        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
          <button class="btn btn-sm btn-success" type="button" @click="submit"> <i class="fas fa-bolt fa-fw"></i> Habilitar</button>
        </div>

      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal, BOverlay } from 'bootstrap-vue';

export default {
  components: { BModal, BOverlay },
  props: ['id', 'code', 'showModal'],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$emit('update:showModal', false);
      this.$emit('getRecords');
    },
    cancel() {
      this.$emit('update:showModal', false);
    },
    submit() {
      this.loading = true;

      axios.post('/administration/assignCourses/enableModules', { id: this.id })
        .then(response => {
          if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
            this.close();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            toastr.error(Object.values(errors)[0][0], 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.error('No se pudieron habilitar los módulos', 'Error', { icon: 'fa fa-times-circle' });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
}
</script>
